import { Box, Paper, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { BookingData } from "../../../types/view-booking";
import { MemoryTableStats } from "./components/MemoryTableStats";
import apiService from "../../../../../service/Api";
import { RecentCommentsSidebar } from "./components/RecentComments";
import MemoryTypesSidebar from "./components/MemoryTypes";
import { useMemoryMessages } from "./hooks/useMemoryMessages";
import MemoryTableContent from "./components/MemoryTableContent";
import { TopContributorsSidebar } from "./components/TopContributers";
import ContactTypesSidebar from "./components/ContactType";

interface MemoryTableTabProps {
  bookingData: BookingData | null;
}

const MemoryTableTab: React.FC<MemoryTableTabProps> = ({ bookingData }) => {
  const [streamId, setStreamId] = useState<number | null>(null);
  const [statsRefresh, setStatsRefresh] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const { messages, refresh: refreshMessages } = useMemoryMessages(streamId);

  const triggerRefresh = useCallback(() => {
    setStatsRefresh((prev) => prev + 1);
    refreshMessages();
  }, [refreshMessages]);

  const fetchStreamId = useCallback(async () => {
    if (!bookingData?.id) return;
    try {
      const res = await apiService.get<{ results: { id: number }[] }>(
        `/api/streams/stream/?booking=${bookingData.id}`,
      );
      const results = res.data?.results;
      if (results?.length > 0) setStreamId(results[0].id);
    } catch (err) {
      console.error("Failed to fetch stream:", err);
    }
  }, [bookingData?.id]);

  useEffect(() => {
    fetchStreamId();
  }, [fetchStreamId]);

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <MemoryTableStats bookingId={bookingData?.id} refresh={statsRefresh} />
      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Paper
            sx={{
              borderRadius: 3,
              p: 3,
              boxShadow: 0,
              mb: 2,
              textAlign: "center",
            }}
          >
            <Typography sx={{ color: "#94a3b8", fontSize: "13px" }}>
              Stream Details here
            </Typography>
          </Paper>
          <MemoryTableContent
            messages={messages}
            activeTab={activeTab}
            onStatsChange={triggerRefresh}
            onTabChange={setActiveTab}
          />
        </Box>
        <Box sx={{ width: 280, flexShrink: 0 }}>
          {activeTab === 0 ? (
            <RecentCommentsSidebar messages={messages} />
          ) : (
            <TopContributorsSidebar messages={messages} />
          )}
          {activeTab === 0 ? (
            <MemoryTypesSidebar messages={messages} />
          ) : (
            <ContactTypesSidebar messages={messages} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MemoryTableTab;
